import React, { useEffect, useState } from "react";
import { Form, Input, Modal, theme, Col, Row, Select, Spin } from "antd";
import { PATCH, POST, PUT } from "../../../frameworks/HttpClient";
import { URL_COMMON, URL_CUSTOMER, URL_TRUCK } from "../../../constants/urls";
import useDropdownItem from "../../../common/useDropdownItem";
import ErrorMessages from "../../../common/ErrorMessages";
import { VEHICLE_TYPE_OPTIONS } from "../../../constants/string";
import _ from 'lodash';

export default function SellVehicleModal(props) {
  const { open, onClose, target, onUpdate, supplier } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const isCreate = (target === 'add')
  const [errorMessages, setErrorMessages] = useState(null);
  const [debouncedSupplier, setDebouncedSupplier] = React.useState('');
  const typeDropdown = useDropdownItem({ url: URL_TRUCK.VEHICLE_TYPE, label: 'name', value:'id', pagination: true, params: { page_size: 999 } })
  const supplierDropdown = useDropdownItem({ url: URL_CUSTOMER.RAW_LATEX_SUPPLIER, label: 'name', value:'id', pagination: true, params: { page_size: 100, name : debouncedSupplier} })
  const provinceDropdown = useDropdownItem({ url: URL_COMMON.PROVINCE, label: 'name_th', value:'id', params: { page_size: 999} })
  
  const debounceSupplier = React.useCallback(_.debounce((_searchVal) => { setDebouncedSupplier(_searchVal) }, 800), []);

  useEffect(() => {
    if (target) {
      form.setFieldsValue(target);
    } else {
      form.resetFields();
    }
  }, [open]); 


  const {
    token: { colorWarning, colorSuccess },
  } = theme.useToken();

  const handleOK = async () => {
    setLoading(true);
    setErrorMessages(null);
    
    try {
      const data = await form.validateFields();
      if(supplier){
        data['supplier'] = supplier.id;
      } else {
        if(!data.supplier)
          data['supplier'] = null;
      }
      if (isCreate) {
        await POST(URL_TRUCK.VEHICLE, data);
      } else {
        await PATCH(`${URL_TRUCK.VEHICLE}${target.id}/`, data);
      }
      onUpdate();
    } catch (error) {
        setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
      supplierDropdown.fetchOptions();
  },[debouncedSupplier])

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      okText={isCreate ? "เพิ่ม" : "แก้ไข"}
      cancelText="ยกเลิก"
      title={isCreate ? "เพิ่มรถขนน้ำยางสด" : "แก้ไขรถขนน้ำยางสด"}
      width={500}
      onOk={handleOK}
      destroyOnClose
      okButtonProps={{
        style: { backgroundColor: isCreate ? colorSuccess : colorWarning },
        loading,
      }}
    >
      <ErrorMessages message={errorMessages}/>
      
      <Form form={form} layout="vertical">
        <Row gutter={10}>

          <Col span={12}>
            <Form.Item
              label="ทะเบียนรถ"
              name="license_plate"
              rules={[
                { required: true, message: "กรุณากรอกข้อมูล" },
              ]}
            >
              <Input placeholder="ทะเบียนรถ" autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item
              label="จังหวัด"
              name="province"
              rules={[
                { required: true, message: "กรุณากรอกข้อมูล" },
              ]}
            >
              <Select
                showSearch
                placeholder="จังหวัด"
                options={provinceDropdown.options}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="ประเภทรถ"
              name="type"
            >
              <Select
                allowClear
                placeholder="ประเภทรถ"
                autoComplete="off"
                options={typeDropdown.options}
                onChange={(value, option) => {
                  if (!value) {
                    form.setFieldValue('type', null)
                  }
                }}
              />
            </Form.Item>
          </Col>

          {!supplier && <Col span={24}>
            <Form.Item
              label="เจ้าของ (ผู้ขายน้ำยางสด)"
              name="supplier"
            >
              <Select 
                initialvalues={"-"}
                autoComplete="off" 
                placeholder="เจ้าของ (ผู้ขายน้ำยางสด)"
                showSearch
                filterOption={false}
                notFoundContent={supplierDropdown.loading ? <Spin size="small" /> : "-"}
                onSearch={debounceSupplier}
                options={supplierDropdown.options}
                allowClear={"-"}/> 
            </Form.Item>
          </Col>}
        </Row>
      </Form>
    </Modal>
  );
}
